<div
	class="loading-overlay"
	*ngIf="loading">
	<div class="k-i-loading"></div>
</div>
